/**
 * Every failure out of `@modules/api`. `message` is written for a person — components surface it
 * directly — while `path` and `status` carry the debugging detail. Its own module so UI helpers
 * can import it without the API surface.
 */
export class ApiError extends Error {
    readonly status?: number;
    readonly path: string;

    constructor(
        message: string,
        { path, status, cause }: { path: string; status?: number; cause?: unknown },
    ) {
        super(message, { cause });
        this.name = 'ApiError';
        this.path = path;
        this.status = status;
    }
}

/**
 * The message to show a user. Only {@link ApiError} messages are written for people; anything
 * else is a programming error whose text would be noise, so callers supply the wording.
 */
export function userMessage(error: unknown, fallback: string): string {
    return error instanceof ApiError && error.message ? error.message : fallback;
}
